import { render } from "./BoxPrintClose.vue?vue&type=template&id=6e96e2fe"
import script from "./BoxPrintClose.vue?vue&type=script&lang=js"
export * from "./BoxPrintClose.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__